var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _path7, _path8, _path9, _polygon3, _path10, _path11, _polygon4, _polygon5, _path12, _path13, _path14, _path15, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon6, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _polygon7, _polygon8, _polygon9, _polygon10, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _path51, _path52, _path53, _path54, _path55, _polygon16, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _polygon17, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _path101, _path102;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 374.24 306.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 119.32,
    y1: 148.05,
    x2: 122.41,
    y2: -55.23,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -737.38,
    y1: 90.09,
    x2: -734.81,
    y2: 88.16,
    gradientTransform: "translate(-505.61 352) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -982.47,
    y1: 326.9,
    x2: -328.94,
    y2: -161.88,
    gradientTransform: "translate(-505.61 352) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -762.66,
    y1: 184.94,
    x2: -694.83,
    y2: -30.49,
    gradientTransform: "translate(-505.61 352) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -724.19,
    y1: 225.84,
    x2: -765.66,
    y2: -54.52,
    gradientTransform: "translate(-532.09 335.01) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -765.32,
    y1: 186.64,
    x2: -797.28,
    y2: -29.39,
    gradientTransform: "translate(-532.09 335.01) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -787.53,
    y1: 122.49,
    x2: -804.53,
    y2: 78.76,
    gradientTransform: "translate(-505.61 352) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -712.32,
    y1: 295.39,
    x2: -639.47,
    y2: -340.86,
    gradientTransform: "translate(-505.61 352) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 224.71,
    y1: 268.52,
    x2: 107.66,
    y2: 67.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 189.86,
    y1: 254.1,
    x2: 226.57,
    y2: 134.07,
    gradientTransform: "matrix(1, 0, 0, -1, -26.48, 335.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 202.6,
    y1: 221.13,
    x2: 367.36,
    y2: 55.32,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 224.95,
    y1: 119.19,
    x2: 220.16,
    y2: 216.78,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 291.73,
    y1: 112.6,
    x2: 275.79,
    y2: 151.72,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 98.76,
    y1: 129.88,
    x2: 120.94,
    y2: 129.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 89.54,
    y1: 129.68,
    x2: 97.96,
    y2: 129.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 86.84,
    y1: 188.87,
    x2: 108.8,
    y2: 127.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 148.71,
    y1: 96.14,
    x2: 163.73,
    y2: 162.02,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 146.63,
    y1: 96.61,
    x2: 161.65,
    y2: 162.49,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 150.08,
    y1: 95.82,
    x2: 165.09,
    y2: 161.71,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 147.9,
    y1: 96.32,
    x2: 162.92,
    y2: 162.2,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 147.45,
    y1: 96.42,
    x2: 162.46,
    y2: 162.31,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 136.58,
    y1: 98.9,
    x2: 151.6,
    y2: 164.78,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 137.12,
    y1: 98.77,
    x2: 152.13,
    y2: 164.66,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 112.46,
    y1: 104.4,
    x2: 127.47,
    y2: 170.28,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 113.57,
    y1: 104.15,
    x2: 128.59,
    y2: 170.03,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 122.23,
    y1: 102.17,
    x2: 137.25,
    y2: 168.05,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 104.71,
    y1: 106.16,
    x2: 119.73,
    y2: 172.05,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 118.28,
    y1: 103.07,
    x2: 133.3,
    y2: 168.96,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 116.2,
    y1: 103.54,
    x2: 131.22,
    y2: 169.43,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 119.66,
    y1: 102.76,
    x2: 134.67,
    y2: 168.64,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 117.46,
    y1: 103.25,
    x2: 132.48,
    y2: 169.14,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 135.33,
    y1: 99.18,
    x2: 150.34,
    y2: 165.07,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 133.22,
    y1: 99.66,
    x2: 148.23,
    y2: 165.55,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 136.68,
    y1: 98.88,
    x2: 151.7,
    y2: 164.76,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 134,
    y1: 99.49,
    x2: 149.02,
    y2: 165.37,
    xlinkHref: "#linear-gradient-11"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M197,17.31a218.94,218.94,0,0,0-104.33,33C78,59.61,64.11,70.93,55,85.74s-12.88,33.57-7,49.91c3.51,9.71,10.11,17.95,14.82,27.13s7.42,20.48,2.73,29.67C60.17,203.09,47.19,207,38,214.66c-14.59,12.14-12.93,23.1-8,38.94,4.27,13.84,11.13,25.82,22.26,35.28,21.74,18.48,51.84,24.19,79.17,28.73,39.6,6.58,80.2,8.3,120.06,3,19.51-2.58,37.72-8,56.63-12.77,18.48-4.63,37.1-10.41,52.86-21.45a93.21,93.21,0,0,0,28.4-120.88c-15.76-29-45.66-47.7-63.83-75.21C314.87,74.14,308.44,55.23,296,40.42,284.57,27,254.41,21.72,238.06,19.18a188.43,188.43,0,0,0-24.76-2.13C207.87,16.93,202.43,17,197,17.31Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8,243.69c3.58,2.58,7.17,5.16,10.94,7.45,6.83,4.15,14.19,7.34,21.52,10.51,2.14.92,4.29,1.85,6.44,2.74a11.82,11.82,0,0,0,4.4,1.16c3.35,0,6-2.62,9-4.2,2.61-1.39,5.57-2,8.21-3.3,1-.48,2-1.28,1.91-2.35s-1-1.58-1.87-2c-7.61-4-15.9-6.65-24.13-9.22a10.52,10.52,0,0,0-4.11-.72c-2.63.24-4.68,2.33-7.17,3.21a13.33,13.33,0,0,1-5.14.52C101.92,247.12,95.63,243.76,88.8,243.69Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.08,262.5l-.57.08C230.09,262.91,231.26,263,231.08,262.5Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.86,196.1c4.27,1.71,8.76,3.37,11.53,5.33L181,247.5a157.54,157.54,0,0,0,15.68,10c4.42,2.39,6.94,7,12.3,8.16a21.31,21.31,0,0,0,8-.14,74.82,74.82,0,0,0,12.68-3.22c.51-.17,1.22-.28,1.45.21h0c38.21-5.22,74.75-19.09,112.63-26.31a2.08,2.08,0,0,0,.39-4,51.36,51.36,0,0,0-9.78-2.4c-6-1.12-12.07-2.21-18.13-3.2a307.38,307.38,0,0,0-36.93-4.1c-20.56-.83-41.3,1.33-61.63-1.86-19.32-3-37.54-10.75-55.52-18.46-4.33-1.86-8.75-3.79-12.15-7-2.66-2.55-4.8-5.94-8.2-7.62s-7.78-1.44-11.6-1.26a172.4,172.4,0,0,0-22.4,3C106.39,191.5,105.09,193.79,103.86,196.1Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M342,223.26l-85.82-37.33a10.27,10.27,0,0,0-6-1L144,194c-2,.29-1.67,9,0,10.42l62.69,53.36a15.75,15.75,0,0,0,14,3.52L341.26,232C342.79,231.58,343.45,224,342,223.26Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M342,223.26l-85.82-37.33a10.27,10.27,0,0,0-6-1L144,194c-2,.29-1.67,9,0,10.42l62.69,53.36a15.75,15.75,0,0,0,14,3.52L341.26,232C342.79,231.58,343.45,224,342,223.26Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144,198.18l62.68,53.36a15.71,15.71,0,0,0,14,3.51L341.2,225.76a2,2,0,0,0,1.06-2.62,2,2,0,0,0-.76-.9l-33.05-18.65-8.67-4.87-26.39-14.89a10.27,10.27,0,0,0-6-1l-122.3,10.65C143.05,193.77,142.38,196.78,144,198.18Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "240.96 168.79 129.12 185.34 163.55 213.28 278.32 190.06 240.96 168.79",
    fill: "url(#linear-gradient-5)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "252.66 197 206.57 206.31 230.4 225.75 278.32 215 252.66 197",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M302.18,235.36a7.43,7.43,0,0,1-4.75,3.89c-3.38.81-23.12,5.86-23.12,5.86s-3.21.39-5-1.76Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.94,182.83l-126.21,18a3.67,3.67,0,0,1-4.1-2.91l-18-90.92a7,7,0,0,1,5.44-8.27,6.21,6.21,0,0,1,.85-.12l124.64-11a7,7,0,0,1,7.62,6.25Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.94,182.83,145.06,200.74a4,4,0,0,1-4.5-3.19L122.62,107a7,7,0,0,1,5.44-8.27,6.21,6.21,0,0,1,.85-.12l124.65-11a7,7,0,0,1,7.62,6.25Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-8)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "120.52 178.57 102.6 86.83 230.04 77.97 240.15 164.82 120.52 178.57",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.81,158.89a33.44,33.44,0,1,1-66.88,0h0a21.57,21.57,0,0,1,.1-2.55,33.44,33.44,0,0,1,66.78,2.55Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.31,174.08c-1.1,4.83.25,10-.74,14.8a33.59,33.59,0,0,1-16.64-18.56,20.4,20.4,0,0,1,.13-5,13.34,13.34,0,0,0,.05-5.34,12.25,12.25,0,0,0-2.08-3.65,33.38,33.38,0,0,1,14-24.7,1.94,1.94,0,0,1,0,.68l-1.43,6.37a19.38,19.38,0,0,1,0,5.69,6.58,6.58,0,0,1-3.1,4.57,13.68,13.68,0,0,0-1.8.89,5.77,5.77,0,0,0-1.36,1.63,13.42,13.42,0,0,0-2,4.26,4.77,4.77,0,0,0,1.06,4.41l9.32-1.81c1-.19,2.16-.32,2.83.42s.3,2.27.48,3.45c.22,1.51,1.56,2.59,2.18,4C279.24,168.66,277.93,171.44,277.31,174.08Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#020202",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.81,158.89a33.37,33.37,0,0,1-12.74,26.27,4.27,4.27,0,0,1-1.16-1.16,3.41,3.41,0,0,1,.92-4.73l0,0c-.56.29-2.77-.43-3.43-.54l-3.44-.53c-1.65-.25-4.53-.15-5.49-1.81a3.86,3.86,0,0,0-.39-.65,2.06,2.06,0,0,0-.71-.49c-1-.51-2.25-1.08-2.5-2.21-.17-.82.24-1.76-.18-2.5-.14-.22-.34-.4-.47-.63a2.14,2.14,0,0,1,.23-2.1c1.45-2.54,4.46-3.76,7.34-4.25s5.86-.41,8.67-1.23a37.56,37.56,0,0,1,5.29-1.62c1-.14,2.26-.24,2.63-1.19.21-.53,0-1.16.22-1.7.08-.23.23-.44.32-.67a1.38,1.38,0,0,0-.89-1.73,1.22,1.22,0,0,0-.26-.06c.23-.63.42-1.43-.07-1.88a1.33,1.33,0,0,0-1.22-.19c-1.2.31-2.07,1.32-3.08,2-3.34,2.37-7.91,1.53-10.7-1.26a3,3,0,0,1-.93-1.51,2.43,2.43,0,0,1,1.42-2.4,7,7,0,0,1,2.89-.57l-1.1-7.25c-5.56,1.49-7.82-3.8-8.61-8.2s2.33-6,6.36-6.27A33.46,33.46,0,0,1,324.81,158.89Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#020202",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.69,161.42c1,9,1.06,18.11,2.67,27,.37,2,1,4.28,2.78,5.29a7.16,7.16,0,0,0,4.52.4,93.67,93.67,0,0,0,27.43-8.18A181,181,0,0,0,191,151.17c-1.27-2.9-2.66-5.84-4.92-8.06-3.43-3.36-8.18-4.42-12.74-5.32-2.37-.47-4.78-.79-7.13-1.39-1.45-.37-5.57-2.79-6.77-2.56-4,.75,0,7.07,1,9.52A66,66,0,0,1,164.69,161.42Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-9)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "222.05 114.03 126.74 123.06 124.31 111.92 219.63 102.88 222.05 114.03",
    fill: "#39bbe7"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "222.05 114.03 126.74 123.06 124.31 111.92 219.63 102.88 222.05 114.03",
    fill: "url(#linear-gradient-10)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.25,124.49c7.36-.79,14.49,3.9,18.43,10.16s5,9.29,5.5,16.67c.16,2.4.36,5.06,2.13,6.69,2.95,2.71,7.56.6,11.42-.46,9.15-2.52,19.78,2.84,23.2,11.7,3.34,8.65-1.44,21.49,6.16,26.81,6.77,4.72,25-6.67,30.71-16.92,0,0,1.66,22.51-16.11,33.76-26.37,16.7-75.8,23.19-81,22.63-8.65-.95-18.09-3.95-22.23-11.6S215,206.66,215,197.83c0-5.08-2.29-11.44-7.37-11.55-3.8-.09-6.55,3.53-8.32,6.89s-3.62,7.23-7.23,8.43c-3.22,1.07-6.88-.52-9.09-3.09s-3.22-6-3.9-9.29c-2.35-11.54-1.28-23.53-3.17-35.16-.72-4.42-2-8.95-5-12.26s-10.05-8.21-15.43-8Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M238.25,124.49c7.36-.79,14.49,3.9,18.43,10.16s5,9.29,5.5,16.67c.16,2.4.36,5.06,2.13,6.69,2.95,2.71,7.56.6,11.42-.46,9.15-2.52,19.78,2.84,23.2,11.7,2.78,7.2,1.12,15.28,3.81,22.49,1.56,4.2,4.07,4.7,8.44,4.39A24.31,24.31,0,0,0,323,191.71c5.23-3.61,9.25-8.68,13.19-13.67-.93,6.15-.77,12.54-2.86,18.39-3.45,9.68-12.4,16.24-21.33,21.33A164,164,0,0,1,263.21,236c-8,1.62-16.38.37-24.48-.51-8.65-1-18.09-4-22.23-11.6s-1.45-17.27-1.42-26.1c0-5.08-2.29-11.44-7.37-11.55-3.8-.09-6.55,3.53-8.32,6.89s-3.62,7.23-7.23,8.43c-3.22,1.07-6.88-.52-9.09-3.09s-3.22-6-3.9-9.29c-2.35-11.54-1.28-23.53-3.17-35.16-.72-4.42-2-9-5-12.26s-10.05-8.21-15.43-8Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-11)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M269.32,159.24l-62.15,23.5s-3.43.83-7.78,10.43-19.86,13-20.65-17.64-2.41-28.7-6.3-35.06L262,149.33S261.41,161.49,269.32,159.24Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-12)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.85,135.06c2.8,3.21,4.28,7.34,5.4,11.45,3.47,12.6,4.22,25.81,3.94,38.89-.1,4.65-.31,9.4,1,13.85a20.94,20.94,0,0,0,13.68,13.81c3.75,1.16,7.88,1.27,11.25,3.28,6.67,4,7.51,13.37,12.56,19.28,6.79,7.94,20.37,8.69,25,18",
    transform: "translate(-26.48 -16.99)",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 165.55,
    y1: 121.84,
    x2: 212.51,
    y2: 116.83,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 170.92,
    y1: 136.88,
    x2: 217.88,
    y2: 131.87,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 173.18,
    y1: 146.91,
    x2: 220.15,
    y2: 141.9,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 205.77,
    y1: 125.67,
    x2: 214.89,
    y2: 124.7,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 187.52,
    y1: 127.62,
    x2: 199.88,
    y2: 126.3,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 167.92,
    y1: 129.71,
    x2: 178.96,
    y2: 128.53,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 208.46,
    y1: 166.91,
    x2: 254.44,
    y2: 149.84,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 212.19,
    y1: 181.86,
    x2: 258.17,
    y2: 164.79,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 213.4,
    y1: 192.16,
    x2: 259.39,
    y2: 175.09,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 247.05,
    y1: 161.08,
    x2: 255.97,
    y2: 157.77,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 229.18,
    y1: 167.71,
    x2: 241.28,
    y2: 163.22,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 209.99,
    y1: 174.84,
    x2: 220.8,
    y2: 170.82,
    fill: "none",
    stroke: "#473f47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.48,184.83s-43,38.38-72,34.29c0,0-23.83,26.91-33.17,11.16S233,204.39,233,204.39l69.69-12.65S307.31,207.29,331.48,184.83Z",
    transform: "translate(-26.48 -16.99)",
    opacity: 0.45,
    fill: "url(#linear-gradient-13)",
    style: {
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.43,248.35c.09,1.16,1.74,1.18,3.61,1s1.37.26,4,.29,3.53-.83,3.66-1.2-1.15-.61-2.5-.94l-.52-.13c-1.52-.39-2.53-1.53-3.83-2.52s-2.82-4.36-2.82-4.36l-3.59-.16s1.51,3.06,2.08,4.38a4.47,4.47,0,0,1,0,2.46A4.67,4.67,0,0,0,120.43,248.35Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#ffb27d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124,249.31c1.87-.22,1.37.26,4,.29s3.53-.83,3.66-1.2-1.15-.61-2.5-.94h0a7.41,7.41,0,0,1-3.85.69c-1.76-.18-3.55-.91-4.76-1a4.56,4.56,0,0,0-.13,1.22C120.52,249.51,122.17,249.53,124,249.31Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#473f47"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.58,247.17l.39.2a27.41,27.41,0,0,0,5,1.66,4.21,4.21,0,0,0,1.73.13,2.49,2.49,0,0,0,1-.44c.14-.11.28-.28.2-.43a.33.33,0,0,0-.12-.14c-.76-.61-1.71-.8-2.51-1.35s-1.44-1.18-2.18-1.74c-1.24-.95,0-6.54,0-6.54l-3.93-.38s.18,4.71.18,6.84c0,.64-.54,1.5,0,2A.88.88,0,0,0,96.58,247.17Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#ffb27d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99.33,249.51a17.09,17.09,0,0,0,2.2.82,7.26,7.26,0,0,0,2.26.4,3.33,3.33,0,0,0,2.15-.71.69.69,0,0,0,.3-.49.82.82,0,0,0-.19-.47,4.14,4.14,0,0,0-1.39-1.24c-.29-.14-.46,0-.74.15a5.76,5.76,0,0,1-1,.3,7.33,7.33,0,0,1-6.6-1.94s-.07-.09-.12-.1-.2.1-.22.22a1.38,1.38,0,0,0,.2,1.1,2.47,2.47,0,0,0,.69.64A14.56,14.56,0,0,0,99.33,249.51Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#473f47"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.32,152a10.61,10.61,0,0,0,.1-1.87,4,4,0,0,0-.48-1.85c-.21-.38-.79-.73-.94-1.08a8.64,8.64,0,0,0-5.55-4.48,9.81,9.81,0,0,0-5.16.69,3.26,3.26,0,0,0-1.18.58,2.94,2.94,0,0,0-.67,1.06,21.83,21.83,0,0,0-1,2.58,7.67,7.67,0,0,0-3-2.63,4.37,4.37,0,0,0-4.21.82,5.64,5.64,0,0,0-1.9,3.92,12,12,0,0,1-.22,2.87,3.16,3.16,0,0,1-2.54,2.1,5.12,5.12,0,0,0,5.18,2.19,20.09,20.09,0,0,1-1.2,2.3,5.67,5.67,0,0,0,3.85-.26,5.76,5.76,0,0,0,1.82-2.16l-.83,1.81c1.44-1.36,1.08-4,2.58-5.27.43.21.59.74.89,1.11s1,.5,1.16,0a6.76,6.76,0,0,0,1.12,3.19,4.36,4.36,0,0,0,3.76,1.7c.27,0,.61-.2.52-.44.65-.14,1-.84,1.58-1.19.75-.47,1.72-.24,2.6-.39a3.93,3.93,0,0,0,2.53-1.86A8.44,8.44,0,0,0,107.32,152Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#fc682d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.64,162.55a5.9,5.9,0,0,1-3.66.66,4.74,4.74,0,0,1-2.44-2.33c.63-.13.81-1,.8-4.71l.28.06,4.79.94s-.11,1.51-.11,2.93C104.29,161.29,104.37,162.42,104.64,162.55Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#ffb27d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.41,157.17s-.11,1.51-.11,2.93c-2.68-.08-4.1-2.52-4.68-3.87Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#ed975d"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M123.88,242.35a1.19,1.19,0,0,1-.78,1.48.93.93,0,0,1-.29,0l-1.87.09-2,.06a1.55,1.55,0,0,1-1.28-.59,55.29,55.29,0,0,1-9.39-17.77c-.08-.26-.17-.53-.26-.8-2-5.67-6-12.8-8.11-19.25-.34-1-.64-2-.92-2.9-.08-.3-.17-.59-.25-.87A68.51,68.51,0,0,1,96.32,189l15.36.12A337.26,337.26,0,0,0,123.88,242.35Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#473f47"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M109.53,180.31c0,7.31,1.07,10.44,1.07,10.44a20.63,20.63,0,0,1-14.39.88l-6.47-1.48c.13-.3,1.29-5.22,1.42-5.49,1.65-3.55,2.9-5.1,3.1-6.19a23.23,23.23,0,0,0,.19-6.12,49.1,49.1,0,0,0-1.9-9.61,50.4,50.4,0,0,0,6.34-2.17,5,5,0,0,0,3.42,1.27c1.56,0,2.06-.7,2-1.43,1.66.92,3,1.79,3,1.79,1.41,2.45,4.27,4.83,4.47,8.59C111.8,171.71,109.53,180.11,109.53,180.31Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.32,181.12c-.67.95-2,6.73-5.16,7.46,1.65-4.12,2.9-5.93,3.1-7.19a31.32,31.32,0,0,0,.19-7.11c1.07-1.88,1.87-3.17,1.87-3.17.09-.3,1.7-5.31,2.22-.83A20.66,20.66,0,0,1,96.32,181.12Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105.3,158.52s-6.33.1-6.34-3.84-.82-6.59,3.22-6.83,4.84,1.27,5.16,2.59S107,158.39,105.3,158.52Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#ffb27d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M105.07,147.76s-1.74,4.63-4.4,5.31-3.81,0-3.81,0a7.54,7.54,0,0,0,2.46-4.45S103.76,145.55,105.07,147.76Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#fc682d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.64,148.13a5.79,5.79,0,0,1,1.61,2c.32,1,.46,3.07,1.06,3,0,0,1.31-3.14-.16-4.92S104.64,148.13,104.64,148.13Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#fc682d"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.32 166.15 96.07 174.5 94.53 175.5 88.08 168.59 91.32 166.15",
    fill: "#ffb27d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M105.18,161.51s3.73.67,5.17,2.6,5.86,16,6.76,17.33,1.59,2.43,1.59,2.43a7.37,7.37,0,0,1-3.17,2.28C113.8,186.62,105.18,161.51,105.18,161.51Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M104.29,160.41s3.67,9.05,3.78,10.89.43,30,.43,30-.22,1.29,2.26.75a8.32,8.32,0,0,0,3.13-1.07s-2.37-17.36-1.73-23.39-5-15.88-5-15.88Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M120.94,244l-2.14.06a1.2,1.2,0,0,1-1-.45,55.45,55.45,0,0,1-9.5-17.91c-.08-.26-.17-.53-.26-.8-2-5.67-6-12.8-8.11-19.25-.34-1-.64-2-.92-2.9-.08-.3-.17-.59-.25-.87l2.26-1.71s6.79,11,8.89,21.34C111.74,230.46,119.05,241.28,120.94,244Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-14)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.26,222.44c0,4.76-.19,15.37-.77,20.55a.93.93,0,0,1-.93.84H96.44a.63.63,0,0,1-.6-.5c-1.59-8.11-2.73-14.84-3.56-20.66-.7-4.88-1.32-9-1.8-12.65s-.82-6.65-.94-9.21v-2.29l13.27-1.29C102.6,206,101.24,219.52,101.26,222.44Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#473f47"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98,243.83H96.55a.76.76,0,0,1-.73-.6c-1.58-8.07-2.71-14.77-3.54-20.56-.7-4.88-1.32-9-1.8-12.65s-.82-6.65-.94-9.21l4.87,2.87s-3.1,1.09-1.92,9.39S96.3,242.65,98,243.83Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-15)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M98.58,200.72s-.93,3.38-4.17,2.95a38.86,38.86,0,0,1-7.83-2.37s1.38-4.37,3.1-10.11c2.08-6.94,4.66-15.89,5.87-21.54a36,36,0,0,0,.66-3.85l2.68-5.21s4,9,4.22,11.24S98.58,200.72,98.58,200.72Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M98.44,176.58c-.15,3.66-1,10.78-8.7,14.58h-.06c2.08-6.94,4.66-15.89,5.87-21.54C97,171.76,98.52,174.56,98.44,176.58Z",
    transform: "translate(-26.48 -16.99)",
    fill: "url(#linear-gradient-16)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.89,160.59s-6.56.47-8.14,4-1.51,8.17-1.36,11.93c.09,2.28.15,4.65,1.22,6.72a30.19,30.19,0,0,0,5.25,6.5,2.73,2.73,0,0,0,1.15.83,2.39,2.39,0,0,0,1.49-.19,8.26,8.26,0,0,0,2.86-1.91c-.33-.29-.46-1-.71-1.43a17.06,17.06,0,0,1-1-1.89,42.18,42.18,0,0,0-2-3.83,23.17,23.17,0,0,1-2-3.17,4.24,4.24,0,0,1,.07-3.6,32.92,32.92,0,0,0,1-4.26C97.44,167.06,98.16,163.82,98.89,160.59Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M134.58,236.54c-1.38-.62-2.5.17-2.5,1.77a4.77,4.77,0,0,0,2.5,4c1.38.62,2.49-.17,2.49-1.77A4.76,4.76,0,0,0,134.58,236.54Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M133.78,236.32a3.85,3.85,0,0,0-1.54.23C131.93,236.69,134,237.87,133.78,236.32Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M134.56,242.65a3.79,3.79,0,0,0,1.53-.22C136.4,242.29,134.31,241.11,134.56,242.65Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M133.67,236.65c-1.38-.62-2.49.17-2.49,1.77a4.74,4.74,0,0,0,2.49,4c1.38.63,2.5-.16,2.5-1.76A4.79,4.79,0,0,0,133.67,236.65Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M133.67,238.7c-.4-.19-.73.05-.73.52a1.39,1.39,0,0,0,.73,1.18c.41.18.74-.05.74-.52A1.39,1.39,0,0,0,133.67,238.7Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.46 213.13 117.06 231 116.73 231.69 91.13 213.81 91.46 213.13",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "94.7 212.16 120.3 230.03 119.98 230.72 94.37 212.84 94.7 212.16",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "98.24 209.78 123.84 227.65 123.51 228.32 97.91 210.46 98.24 209.78",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.89 208.88 127.49 226.75 127.16 227.44 101.56 209.56 101.89 208.88",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M150,247.31c-1.38-.62-2.49.17-2.49,1.77a4.76,4.76,0,0,0,2.49,4c1.38.62,2.5-.17,2.5-1.77A4.77,4.77,0,0,0,150,247.31Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M149.23,247.09a3.85,3.85,0,0,0-1.54.23C147.38,247.46,149.47,248.64,149.23,247.09Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M150,253.42a3.84,3.84,0,0,0,1.54-.22C151.86,253.06,149.77,251.88,150,253.42Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M149.12,247.42c-1.37-.62-2.49.17-2.49,1.77a4.74,4.74,0,0,0,2.49,4c1.38.63,2.5-.16,2.5-1.76A4.79,4.79,0,0,0,149.12,247.42Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M149.12,249.47c-.4-.19-.73.05-.73.52a1.39,1.39,0,0,0,.73,1.18c.41.18.74,0,.74-.52A1.39,1.39,0,0,0,149.12,249.47Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M149.71,246.21a.73.73,0,0,0-.59-.69.48.48,0,0,0-.57.37.49.49,0,0,0,0,.12v4.2a.73.73,0,0,0,.58.69.46.46,0,0,0,.57-.33.39.39,0,0,0,0-.15Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M134.26,235.45a.75.75,0,0,0-.59-.7.49.49,0,0,0-.58.38.41.41,0,0,0,0,.11v4.2a.73.73,0,0,0,.59.69.46.46,0,0,0,.57-.33.39.39,0,0,0,0-.15Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M135.06,204.71l.82,23.71a.4.4,0,0,0,.33.39.28.28,0,0,0,.3-.26v-.05l-.81-23.71a.42.42,0,0,0-.33-.39.28.28,0,0,0-.31.25v.06Zm20.52,14.5-4,20.3a.41.41,0,0,0,.25.45.26.26,0,0,0,.35-.15.14.14,0,0,0,0-.06l4-20.29a.4.4,0,0,0-.2-.46.28.28,0,0,0-.36.13.19.19,0,0,0,0,.07Zm-14.89-10.53-1.48,22.15a.41.41,0,0,0,.3.42.28.28,0,0,0,.33-.21.09.09,0,0,0,0,0l1.48-22.16a.41.41,0,0,0-.3-.42.28.28,0,0,0-.33.21A.13.13,0,0,0,140.69,208.68Zm9.54,6.74L146.6,236a.42.42,0,0,0,.26.44.27.27,0,0,0,.35-.12.29.29,0,0,0,0-.09l3.62-20.56a.42.42,0,0,0-.25-.45.26.26,0,0,0-.35.15.19.19,0,0,0,0,.07Zm-7.32,18a.41.41,0,0,0,.28.43.26.26,0,0,0,.33-.15.29.29,0,0,0,0-.09l2.68-21.23A.41.41,0,0,0,146,212a.26.26,0,0,0-.34.16.24.24,0,0,0,0,.08Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.47,202l31.79,22.62-6,17.31L132,224.72Zm.69,23.62,25.16,17.91a.55.55,0,0,0,.78-.06l.07-.11,6.48-18.63a.82.82,0,0,0-.31-.9L130,200.17a.55.55,0,0,0-.78.06l-.07.11a.84.84,0,0,0-.07.35L130.79,225a.8.8,0,0,0,.37.65Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.19 211.9 91.71 218.59 91.38 217.79 109.87 211.1 110.19 211.9",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "113.53 214.38 95.04 221.06 94.72 220.28 113.21 213.59 113.53 214.38",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "117.02 216.69 98.54 223.38 98.21 222.59 116.7 215.91 117.02 216.69",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.33 219.75 102.84 226.43 102.52 225.63 121.01 218.96 121.33 219.75",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "125.77 223.1 107.28 229.79 106.96 229 125.45 222.31 125.77 223.1",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M114.15,231l-6.05-21.07,21.09-8.19,1.56,22.8Zm17.9-5.89-1.67-24.32a.8.8,0,0,0-.68-.75.58.58,0,0,0-.26.05l-22.4,8.7a.63.63,0,0,0-.32.78L113.17,232a.74.74,0,0,0,.8.58h.11l17.63-6.85A.58.58,0,0,0,132.05,225.11Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M125.44,202.28l2.36,24.05a.4.4,0,0,0,.35.37.28.28,0,0,0,.28-.3v0l-2.35-24.05a.41.41,0,0,0-.35-.37.29.29,0,0,0-.29.29Zm-4.55,1.78,3.5,23.62a.39.39,0,0,0,.37.34.29.29,0,0,0,.27-.31s0,0,0-.05l-3.5-23.61a.39.39,0,0,0-.36-.34.3.3,0,0,0-.28.3S120.89,204,120.89,204.06Zm-8,3.13,4.27,23.31a.38.38,0,0,0,.37.34.3.3,0,0,0,.26-.34v0l-4.27-23.31a.39.39,0,0,0-.38-.33.28.28,0,0,0-.25.31A.11.11,0,0,0,112.89,207.19Zm4.24-1.92a.39.39,0,0,1,.37.34l3.9,23.46a.28.28,0,0,1-.21.35h0a.39.39,0,0,1-.37-.34l-3.9-23.45a.29.29,0,0,1,.2-.36h0Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M131.45,234.11a.73.73,0,0,0,.62.65.47.47,0,0,0,.55-.38.66.66,0,0,0,0-.14l-2.89-42a.73.73,0,0,0-.63-.66.47.47,0,0,0-.54.39.33.33,0,0,0,0,.14Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M129.66,193.15a.92.92,0,0,0,.45-1.23.67.67,0,0,0-.06-.12,1.18,1.18,0,0,0-1.42-.64l-24.13,9.37a.93.93,0,0,0-.47,1.21.54.54,0,0,0,.07.13,1.21,1.21,0,0,0,1.42.65Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M122.08,191.33s3,.93,3.56,2,.82,3.46.39,3.52-1.58-2.33-2-2.43-1-.53-.91-.15.58,1,.42,1.17-.94-.84-1.37-1-.94-1.84-1.42-2.24S122.08,191.33,122.08,191.33Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "74.88 170.82 79.63 179.16 78.1 180.19 71.64 173.26 74.88 170.82",
    fill: "#39bbe7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M105.65,196a3.88,3.88,0,0,1,.72.26,5.07,5.07,0,0,1,1.42.65,6.86,6.86,0,0,1,1.77,2.36,1.7,1.7,0,0,1,.13,1.46,1.92,1.92,0,0,1-.87.67.75.75,0,0,1-.3.09.79.79,0,0,1-.43-.21l-2.21-1.85a3.12,3.12,0,0,1-.82-.88c-.19-.34-.25-.74-.42-1.09s-.51-.55-.26-.89S105.28,196.11,105.65,196Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M115.34,239.8a.69.69,0,0,0,.73.52.48.48,0,0,0,.42-.53l0-.12-10.89-38.22a.71.71,0,0,0-.73-.52.5.5,0,0,0-.42.55l0,.11Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M119,242.89c-1.38-.63-2.49.16-2.49,1.76a4.76,4.76,0,0,0,2.49,4c1.38.62,2.5-.17,2.5-1.77A4.74,4.74,0,0,0,119,242.89Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M118.23,242.66a3.85,3.85,0,0,0-1.54.23C116.38,243,118.47,244.21,118.23,242.66Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M119,249a3.67,3.67,0,0,0,1.54-.22C120.86,248.63,118.77,247.45,119,249Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M118.12,243c-1.37-.62-2.49.17-2.49,1.77a4.74,4.74,0,0,0,2.49,4c1.38.63,2.5-.16,2.5-1.76A4.79,4.79,0,0,0,118.12,243Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M118.12,245c-.4-.19-.73.05-.73.52a1.39,1.39,0,0,0,.73,1.18c.41.19.74,0,.74-.52A1.39,1.39,0,0,0,118.12,245Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M134.48,253.65c-1.37-.62-2.49.17-2.49,1.77a4.76,4.76,0,0,0,2.49,4c1.38.62,2.5-.17,2.5-1.77A4.77,4.77,0,0,0,134.48,253.65Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M133.68,253.43a3.85,3.85,0,0,0-1.54.23C131.84,253.8,133.92,255,133.68,253.43Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M134.46,259.76a3.84,3.84,0,0,0,1.54-.22C136.31,259.4,134.22,258.22,134.46,259.76Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M133.58,253.76c-1.38-.62-2.5.17-2.5,1.77a4.74,4.74,0,0,0,2.5,4c1.38.63,2.49-.16,2.49-1.76A4.76,4.76,0,0,0,133.58,253.76Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M134.17,252.56a.75.75,0,0,0-.59-.7.48.48,0,0,0-.58.36.57.57,0,0,0,0,.13v4.2a.75.75,0,0,0,.59.7.49.49,0,0,0,.58-.38.41.41,0,0,0,0-.11Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M153.05,249.82l-21.3-15.18-14.35,5.47,21.24,15.33,14.41-5.62Zm-14.71,6.73-22.43-16.18a.65.65,0,0,1-.23-.84.45.45,0,0,1,.22-.19l15.56-5.93a.63.63,0,0,1,.58.11l22.5,16a.65.65,0,0,1,.23.84.43.43,0,0,1-.24.2l-15.6,6.08a.63.63,0,0,1-.59-.09Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M118.71,241.79a.72.72,0,0,0-.59-.69.47.47,0,0,0-.57.35.57.57,0,0,0,0,.13v4.2a.74.74,0,0,0,.58.7.48.48,0,0,0,.58-.36.57.57,0,0,0,0-.13Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M136.16,237l-.32-.79-16.23,5.87.32.79Zm3.34,2.49-16.23,5.87-.32-.79,16.23-5.87.32.79ZM143,241.8l-16.23,5.87-.32-.79L142.67,241l.32.79Zm4.31,3-16.23,5.87-.32-.79L147,244.07l.32.79Zm-11.79,9.23-.32-.79,16.23-5.87.32.79Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M150,247.31c-1.38-.62-2.49.17-2.49,1.77a4.76,4.76,0,0,0,2.49,4c1.38.62,2.5-.17,2.5-1.77A4.77,4.77,0,0,0,150,247.31Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-17)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M149.23,247.09a3.85,3.85,0,0,0-1.54.23C147.38,247.46,149.47,248.64,149.23,247.09Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-18)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M150,253.42a3.84,3.84,0,0,0,1.54-.22C151.86,253.06,149.77,251.88,150,253.42Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-19)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M149.12,247.42c-1.37-.62-2.49.17-2.49,1.77a4.74,4.74,0,0,0,2.49,4c1.38.63,2.5-.16,2.5-1.76A4.79,4.79,0,0,0,149.12,247.42Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#473f47",
    fillRule: "evenodd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M149.12,249.47c-.4-.19-.73.05-.73.52a1.39,1.39,0,0,0,.73,1.18c.41.18.74,0,.74-.52A1.39,1.39,0,0,0,149.12,249.47Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-20)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M149.71,246.21a.73.73,0,0,0-.59-.69.48.48,0,0,0-.57.37.49.49,0,0,0,0,.12v4.2a.73.73,0,0,0,.58.69.46.46,0,0,0,.57-.33.39.39,0,0,0,0-.15Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-21)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M135.06,204.71l.82,23.71a.4.4,0,0,0,.33.39.28.28,0,0,0,.3-.26v-.05l-.81-23.71a.42.42,0,0,0-.33-.39.28.28,0,0,0-.31.25v.06Zm20.52,14.5-4,20.3a.41.41,0,0,0,.25.45.26.26,0,0,0,.35-.15.14.14,0,0,0,0-.06l4-20.29a.4.4,0,0,0-.2-.46.28.28,0,0,0-.36.13.19.19,0,0,0,0,.07Zm-14.89-10.53-1.48,22.15a.41.41,0,0,0,.3.42.28.28,0,0,0,.33-.21.09.09,0,0,0,0,0l1.48-22.16a.41.41,0,0,0-.3-.42.28.28,0,0,0-.33.21A.13.13,0,0,0,140.69,208.68Zm9.54,6.74L146.6,236a.42.42,0,0,0,.26.44.27.27,0,0,0,.35-.12.29.29,0,0,0,0-.09l3.62-20.56a.42.42,0,0,0-.25-.45.26.26,0,0,0-.35.15.19.19,0,0,0,0,.07Zm-7.32,18a.41.41,0,0,0,.28.43.26.26,0,0,0,.33-.15.29.29,0,0,0,0-.09l2.68-21.23A.41.41,0,0,0,146,212a.26.26,0,0,0-.34.16.24.24,0,0,0,0,.08Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-22)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M130.47,202l31.79,22.62-6,17.31L132,224.72Zm.69,23.62,25.16,17.91a.55.55,0,0,0,.78-.06l.07-.11,6.48-18.63a.82.82,0,0,0-.31-.9L130,200.17a.55.55,0,0,0-.78.06l-.07.11a.84.84,0,0,0-.07.35L130.79,225a.8.8,0,0,0,.37.65Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-23)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M114.15,231l-6.05-21.07,21.09-8.19,1.56,22.8Zm17.9-5.89-1.67-24.32a.8.8,0,0,0-.68-.75.58.58,0,0,0-.26.05l-22.4,8.7a.63.63,0,0,0-.32.78L113.17,232a.74.74,0,0,0,.8.58h.11l17.63-6.85A.58.58,0,0,0,132.05,225.11Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-24)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M125.44,202.28l2.36,24.05a.4.4,0,0,0,.35.37.28.28,0,0,0,.28-.3v0l-2.35-24.05a.41.41,0,0,0-.35-.37.29.29,0,0,0-.29.29Zm-4.55,1.78,3.5,23.62a.39.39,0,0,0,.37.34.29.29,0,0,0,.27-.31s0,0,0-.05l-3.5-23.61a.39.39,0,0,0-.36-.34.3.3,0,0,0-.28.3S120.89,204,120.89,204.06Zm-8,3.13,4.27,23.31a.38.38,0,0,0,.37.34.3.3,0,0,0,.26-.34v0l-4.27-23.31a.39.39,0,0,0-.38-.33.28.28,0,0,0-.25.31A.11.11,0,0,0,112.89,207.19Zm4.24-1.92a.39.39,0,0,1,.37.34l3.9,23.46a.28.28,0,0,1-.21.35h0a.39.39,0,0,1-.37-.34l-3.9-23.45a.29.29,0,0,1,.2-.36h0Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-25)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M131.45,234.11a.73.73,0,0,0,.62.65.47.47,0,0,0,.55-.38.66.66,0,0,0,0-.14l-2.89-42a.73.73,0,0,0-.63-.66.47.47,0,0,0-.54.39.33.33,0,0,0,0,.14Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-26)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M129.66,193.15a.92.92,0,0,0,.45-1.23.67.67,0,0,0-.06-.12,1.18,1.18,0,0,0-1.42-.64l-24.13,9.37a.93.93,0,0,0-.47,1.21.54.54,0,0,0,.07.13,1.21,1.21,0,0,0,1.42.65Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7",
    fillRule: "evenodd"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M122.08,191.33s3,.93,3.56,2,.82,3.46.39,3.52-1.58-2.33-2-2.43-1-.53-.91-.15.58,1,.42,1.17-.94-.84-1.37-1-.94-1.84-1.42-2.24S122.08,191.33,122.08,191.33Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#ffb27d"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "74.88 170.82 79.63 179.16 78.1 180.19 71.64 173.26 74.88 170.82",
    fill: "#ffb27d"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M105.65,196a3.88,3.88,0,0,1,.72.26,5.07,5.07,0,0,1,1.42.65,6.86,6.86,0,0,1,1.77,2.36,1.7,1.7,0,0,1,.13,1.46,1.92,1.92,0,0,1-.87.67.75.75,0,0,1-.3.09.79.79,0,0,1-.43-.21l-2.21-1.85a3.12,3.12,0,0,1-.82-.88c-.19-.34-.25-.74-.42-1.09s-.51-.55-.26-.89S105.28,196.11,105.65,196Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#ffb27d"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M115.34,239.8a.69.69,0,0,0,.73.52.48.48,0,0,0,.42-.53l0-.12-10.89-38.22a.71.71,0,0,0-.73-.52.5.5,0,0,0-.42.55l0,.11Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-27)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M119,242.89c-1.38-.63-2.49.16-2.49,1.76a4.76,4.76,0,0,0,2.49,4c1.38.62,2.5-.17,2.5-1.77A4.74,4.74,0,0,0,119,242.89Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-28)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M118.23,242.66a3.85,3.85,0,0,0-1.54.23C116.38,243,118.47,244.21,118.23,242.66Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-29)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M119,249a3.67,3.67,0,0,0,1.54-.22C120.86,248.63,118.77,247.45,119,249Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-30)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M118.12,243c-1.37-.62-2.49.17-2.49,1.77a4.74,4.74,0,0,0,2.49,4c1.38.63,2.5-.16,2.5-1.76A4.79,4.79,0,0,0,118.12,243Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#473f47",
    fillRule: "evenodd"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M118.12,245c-.4-.19-.73.05-.73.52a1.39,1.39,0,0,0,.73,1.18c.41.19.74,0,.74-.52A1.39,1.39,0,0,0,118.12,245Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-31)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M134.48,253.65c-1.37-.62-2.49.17-2.49,1.77a4.76,4.76,0,0,0,2.49,4c1.38.62,2.5-.17,2.5-1.77A4.77,4.77,0,0,0,134.48,253.65Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-32)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M133.68,253.43a3.85,3.85,0,0,0-1.54.23C131.84,253.8,133.92,255,133.68,253.43Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-33)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M134.46,259.76a3.84,3.84,0,0,0,1.54-.22C136.31,259.4,134.22,258.22,134.46,259.76Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-34)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M133.58,253.76c-1.38-.62-2.5.17-2.5,1.77a4.74,4.74,0,0,0,2.5,4c1.38.63,2.49-.16,2.49-1.76A4.76,4.76,0,0,0,133.58,253.76Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#473f47",
    fillRule: "evenodd"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M134.17,252.56a.75.75,0,0,0-.59-.7.48.48,0,0,0-.58.36.57.57,0,0,0,0,.13v4.2a.75.75,0,0,0,.59.7.49.49,0,0,0,.58-.38.41.41,0,0,0,0-.11Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M118.71,241.79a.72.72,0,0,0-.59-.69.47.47,0,0,0-.57.35.57.57,0,0,0,0,.13v4.2a.74.74,0,0,0,.58.7.48.48,0,0,0,.58-.36.57.57,0,0,0,0-.13Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M136.16,237l-.32-.79-16.23,5.87.32.79Zm3.34,2.49-16.23,5.87-.32-.79,16.23-5.87.32.79ZM143,241.8l-16.23,5.87-.32-.79L142.67,241l.32.79Zm4.31,3-16.23,5.87-.32-.79L147,244.07l.32.79Zm-11.79,9.23-.32-.79,16.23-5.87.32.79Z",
    transform: "translate(-26.48 -16.99)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-35)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M139.71,248.77l1.51-15.08,20.7-8-5.83,16.76-16.38,6.36Zm17.5-5.49,6.44-18.52a.83.83,0,0,0-.39-.95.67.67,0,0,0-.5-.05l-22.42,8.71a.59.59,0,0,0-.35.49l-1.67,16.71a.83.83,0,0,0,.57.85.53.53,0,0,0,.35,0l17.65-6.86A.56.56,0,0,0,157.21,243.28Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M157.35,226.4,153.4,244a.41.41,0,0,0,.24.46.28.28,0,0,0,.36-.13.19.19,0,0,0,0-.07l4-17.61a.42.42,0,0,0-.24-.45.28.28,0,0,0-.36.13.19.19,0,0,0,0,.07Zm-4.56,1.78a.28.28,0,0,1,.3-.24l.07,0a.42.42,0,0,1,.26.44l-2.8,17.14a.27.27,0,0,1-.29.25l-.08,0a.42.42,0,0,1-.26-.45Zm-8,3.14-2,16.84a.41.41,0,0,0,.28.43.28.28,0,0,0,.34-.18.17.17,0,0,0,0-.07l2-16.84a.41.41,0,0,0-.28-.43.28.28,0,0,0-.34.18A.17.17,0,0,0,144.79,231.32Zm1.59,15.42a.42.42,0,0,0,.27.44A.26.26,0,0,0,147,247v0l2.4-17a.41.41,0,0,0-.27-.44.29.29,0,0,0-.35.19.43.43,0,0,0,0,.05Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M91,147.92a3.44,3.44,0,0,0-.38.93,4.42,4.42,0,0,0,0,3.46,4.74,4.74,0,0,0,.69,1.22,2.07,2.07,0,0,0,1.18.73.38.38,0,0,0,.15,0,.22.22,0,0,0,.1-.09,1.3,1.3,0,0,0,0-.95,7.93,7.93,0,0,1,.26-3.59,4.58,4.58,0,0,0,.23-1.32,1.06,1.06,0,0,0-.79-1.09A1.41,1.41,0,0,0,91,147.92Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.56 191.79 114.52 215.66 113.99 217.34 80.87 193.57 80.56 191.79",
    fill: "#fff",
    fillRule: "evenodd"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.61 198.88 91.77 217.96 92.43 218.16 89.84 199.6 88.61 198.88",
    fill: "#fff",
    fillRule: "evenodd"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "94.76 203.18 96.48 221.53 97.14 221.75 95.99 203.91 94.76 203.18",
    fill: "#fff",
    fillRule: "evenodd"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.79 207.19 100.99 224.66 101.65 224.88 102.02 207.94 100.79 207.19",
    fill: "#fff",
    fillRule: "evenodd"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "105.29 211.01 106.13 228.78 106.79 229 106.52 211.75 105.29 211.01",
    fill: "#fff",
    fillRule: "evenodd"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.26 231.78 87.66 214 87.49 215.62 112.41 233.53 112.26 231.78",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M71.61,105.94v16.93a5.9,5.9,0,0,0,5.8,6h13l5.85,8.47v-8.47h11a5.9,5.9,0,0,0,5.82-6v-17a5.92,5.92,0,0,0-5.82-6H77.42A5.91,5.91,0,0,0,71.61,105.94Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#fff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M90,126.69l.11-2.88A7.62,7.62,0,0,1,86,122.37l.72-1.86a7.16,7.16,0,0,0,3.88,1.38c2,.07,3.31-1,3.37-2.64s-1-2.56-3-3.5c-2.75-1.24-4.43-2.62-4.33-5.07A4.56,4.56,0,0,1,91,106.3l.1-2.88,1.7.07-.1,2.74a7.26,7.26,0,0,1,3.52,1.14l-.74,1.87A6.47,6.47,0,0,0,92,108.13c-2.11-.09-3,1.18-3,2.31-.06,1.47.93,2.24,3.25,3.36,2.79,1.3,4.15,2.83,4,5.34a4.85,4.85,0,0,1-4.51,4.63l-.11,2.94Z",
    transform: "translate(-26.48 -16.99)",
    fill: "#39bbe7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/Retail.20ba9b8222d486d7c79c161591bd9327.svg";
export { ForwardRef as ReactComponent };